var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackYourFootprintMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3555_282581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4514 32.8611C56.6491 31.0332 52.2287 29.6654 49.0501 31.0935C47.9903 31.5701 47.0684 32.3576 46.3905 33.5422C45.3076 35.4361 45.169 37.7619 45.5671 39.9115C46.2653 43.6874 48.4116 46.9953 49.1204 50.7804C49.7765 54.2864 49.1943 57.5042 46.88 60.261C44.6543 62.9127 43.4651 66.2909 43.7091 69.7976C43.8041 71.1597 44.1177 72.5296 44.8153 73.6992C45.617 75.0435 46.8757 75.9078 48.368 76.2934C52.5331 77.3693 54.7455 72.5878 55.7933 69.3715C57.237 64.9388 57.5323 60.1317 59.649 55.9262C60.9577 53.3249 62.9169 51.0929 64.1482 48.454C66.741 42.8963 64.5237 36.1711 59.4514 32.8618V32.8611Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0419 29.1921C51.0944 29.1729 52.7374 26.8826 52.7117 24.0764C52.686 21.2703 51.0013 19.0111 48.9488 19.0302C46.8963 19.0494 45.2533 21.3398 45.279 24.1459C45.3047 26.952 46.9894 29.2113 49.0419 29.1921Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8059 26.7437C59.4031 24.6853 58.7249 22.6726 57.2911 22.2484C55.8573 21.8242 54.2108 23.149 53.6136 25.2074C53.0164 27.2659 53.6946 29.2785 55.1284 29.7027C56.5622 30.1269 58.2087 28.8022 58.8059 26.7437Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2244 30.4145C64.1768 28.9778 64.1378 27.2649 63.1373 26.5885C62.1368 25.9122 60.5537 26.5285 59.6014 27.9651C58.649 29.4018 58.688 31.1147 59.6885 31.7911C60.689 32.4674 62.2721 31.8511 63.2244 30.4145Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9891 34.2274C63.5742 34.846 64.7542 34.667 65.6255 33.8269C66.4968 32.9875 66.7281 31.8051 66.1431 31.1865C65.558 30.568 64.378 30.747 63.5067 31.5871C62.6354 32.4265 62.404 33.6089 62.9891 34.2274Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1772 35.1823C67.6786 34.5979 66.6364 34.6788 65.8488 35.3641C65.0612 36.0487 64.8271 37.0777 65.3249 37.6629C65.8235 38.2474 66.8657 38.1664 67.6533 37.4811C68.4409 36.7965 68.6751 35.7675 68.1772 35.1823Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.879 38.2999C34.5878 34.5141 36.7341 31.2069 37.4324 27.431C37.8304 25.2814 37.6919 22.9556 36.6089 21.0616C35.931 19.8764 35.0091 19.0895 33.9493 18.613C30.7708 17.1842 26.351 18.552 23.548 20.3806C18.475 23.6899 16.2577 30.4151 18.8512 35.9727C20.0825 38.6124 22.0417 40.8444 23.3504 43.445C25.4671 47.6505 25.7624 52.4575 27.2061 56.891C28.2532 60.1073 30.4663 64.8888 34.6314 63.8129C36.1237 63.4273 37.3824 62.563 38.1841 61.2187C38.8817 60.0491 39.1953 58.6792 39.2903 57.3171C39.535 53.8104 38.3458 50.4322 36.1195 47.7805C33.8052 45.0236 33.2229 41.8059 33.879 38.2999Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7234 11.6682C37.7491 8.86207 36.1061 6.57172 34.0536 6.55254C32.0011 6.53337 30.3164 8.79264 30.2907 11.5988C30.265 14.4049 31.908 16.6952 33.9605 16.7144C36.013 16.7336 37.6977 14.4743 37.7234 11.6682Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8751 17.2189C29.3089 16.7946 29.9871 14.782 29.3899 12.7236C28.7926 10.6651 27.1462 9.34034 25.7124 9.76457C24.2785 10.1888 23.6003 12.2014 24.1976 14.2599C24.7948 16.3183 26.4413 17.6431 27.8751 17.2189Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.314 19.3055C24.3145 18.6292 24.3535 16.9162 23.4012 15.4796C22.4488 14.0429 20.8657 13.4266 19.8652 14.103C18.8648 14.7793 18.8258 16.4923 19.7781 17.9289C20.7305 19.3656 22.3136 19.9819 23.314 19.3055Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0116 21.7456C20.5964 21.1269 20.3646 19.9447 19.4938 19.1052C18.6229 18.2656 17.4428 18.0866 16.8579 18.7054C16.273 19.3241 16.5048 20.5063 17.3757 21.3458C18.2465 22.1854 19.4267 22.3644 20.0116 21.7456Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6745 25.1817C18.173 24.5971 17.9386 23.568 17.1511 22.8832C16.3635 22.1983 15.3209 22.1171 14.8225 22.7017C14.324 23.2863 14.5584 24.3154 15.3459 25.0002C16.1335 25.6851 17.1761 25.7663 17.6745 25.1817Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3555_282581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.8772,
    height: 69.8947,
    fill: "white",
    transform: "translate(14.5615 6.55273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackYourFootprintMain);
export default __webpack_public_path__ + "static/media/Track_your_Footprint_Main.c988bcf7241eea8d930209ca5042f877.svg";
export { ForwardRef as ReactComponent };